import React from "react";
import useInView from "../lib/useInView";

export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div", ...rest }) => {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      className={`animate-on-scroll ${inView ? "in-view" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
